// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  background-color: rgb(245, 245, 245);
}

.form__header {
  font-size: 1.2rem;
  margin-bottom: 20px;
  text-align: center;
}

.form__input-text {
  width: 100%;
  border-radius: 5px;
}

.form__row {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.form__label {
  font-weight: bold;
  margin-bottom: 5px;
}

.form__input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.form__row--button {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Form/Form.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  background-color: rgb(245, 245, 245);\n}\n\n.form__header {\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.form__input-text {\n  width: 100%;\n  border-radius: 5px;\n}\n\n.form__row {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n\n.form__label {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.form__input {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.form__row--button {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
